var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29372 5.70626C4.68434 6.09689 5.31872 6.09689 5.70934 5.70626L9.70934 1.70626C9.99685 1.41876 10.0812 0.990637 9.92497 0.615637C9.76872 0.240637 9.40622 -0.00311279 8.99997 -0.00311279L0.99997 1.23978e-05C0.596845 1.23978e-05 0.23122 0.243762 0.0749697 0.618762C-0.0812803 0.993762 0.00621966 1.42189 0.290595 1.70939L4.29059 5.70939L4.29372 5.70626Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownFill);
export default __webpack_public_path__ + "static/media/downFill.17c76b7caa19bce8675e8d59fa7c1315.svg";
export { ForwardRef as ReactComponent };